import { createSelector } from 'reselect';
import { createWizardSlice } from '../../../features/Wizard/slice';

export const CITYSPRINT_WIZARD_STEPS = {
  PARCEL: 'parcel',
  DETAILS: 'details',
  QUICK_QUOTE: 'quickQuote',
};

const SLICE_NAME = 'citysprintWizard';

const baseSlice = createWizardSlice(SLICE_NAME, undefined, {
  patchParcelStep(state, { payload }) {
    state.values[CITYSPRINT_WIZARD_STEPS.PARCEL] = {
      ...(state.values[CITYSPRINT_WIZARD_STEPS.PARCEL] || {}),
      ...payload,
    };
  },

  patchDetailsStep(state, { payload }) {
    state.values[CITYSPRINT_WIZARD_STEPS.DETAILS] = {
      ...(state.values[CITYSPRINT_WIZARD_STEPS.DETAILS] || {}),
      ...payload,
    };
  },

  clearDetailsStep(state) {
    delete state.values[CITYSPRINT_WIZARD_STEPS.DETAILS];
  },

  setQuickQuote(state, { payload }) {
    state.values[CITYSPRINT_WIZARD_STEPS.QUICK_QUOTE] = { ...payload };
  },

  clearQuickQuote(state) {
    delete state.values[CITYSPRINT_WIZARD_STEPS.QUICK_QUOTE];
  },

  resetParcelTimingAndSelection(state) {
    const parcel = state.values[CITYSPRINT_WIZARD_STEPS.PARCEL];
    if (!parcel) {
      return;
    }
    parcel.selectedQuote = null;
    parcel.collectionDate = '';
    parcel.timeHour = '';
    parcel.timeMinute = '';
  },
});

const emptyObject = {};

const getParcelStepValues = createSelector(
  baseSlice.selectors.getValues,
  values => values[CITYSPRINT_WIZARD_STEPS.PARCEL] || emptyObject
);

const getDetailsStepValues = createSelector(
  baseSlice.selectors.getValues,
  values => values[CITYSPRINT_WIZARD_STEPS.DETAILS] || emptyObject
);

const getQuickQuoteValues = createSelector(
  baseSlice.selectors.getValues,
  values => values[CITYSPRINT_WIZARD_STEPS.QUICK_QUOTE] || emptyObject
);

const getSelectedQuote = createSelector(
  getParcelStepValues,
  parcel => parcel.selectedQuote || null
);

export const CitysprintWizardReducer = baseSlice.reducer;
export const CitysprintWizardActions = baseSlice.actions;
export const CitysprintWizardSelectors = {
  ...baseSlice.selectors,
  getParcelStepValues,
  getDetailsStepValues,
  getQuickQuoteValues,
  getSelectedQuote,
};
